const adminFormRouter = [
  {
    path: '/admin/form',
    name: 'AdminFormIndex',
    component: () => import('@/views/admin/form/index')
  },
  {
    path: '/admin/form/create',
    name: 'AdminFormCreate',
    component: () => import('@/views/admin/form/create')
  },
  {
    path: '/admin/form/edit',
    name: 'AdminFormEdit',
    component: () => import('@/views/admin/form/edit')
  },
  {
    path: '/admin/form/record',
    name: 'AdminFormRecord',
    component: () => import('@/views/admin/form/record')
  },
  {
    path: '/admin/form/stat',
    name: 'AdminFormStat',
    component: () => import('@/views/admin/form/stat')
  },
  {
    path: '/admin/form/option',
    name: 'AdminFormOption',
    component: () => import('@/views/admin/form/option')
  }
]

export default adminFormRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/form.js